<template>
  <div
    class="_case_card"
    :style="{
      backgroundImage: `url(${domain}/bimwebsite/public${item.image})`,
    }"
  >
    <div class="_bg"></div>
    <div class="_title" v-if="$store.state.screenWidth > 960">
      <div class="_name">{{ item.name }}</div>
      <div class="_line"></div>
    </div>
    <div class="_m_title" v-else-if="$store.state.screenWidth <= 960">
      <div class="_name">{{ item.name }}</div>
      <div class="_line"></div>
    </div>
    <div class="_info">
      <div class="_title" v-if="$store.state.screenWidth > 960">
        {{ item.name }}
      </div>
      <div class="_m_title" v-else-if="$store.state.screenWidth <= 960">
        {{ item.name }}
      </div>
      <div class="_content" v-if="$store.state.screenWidth > 960">
        <!-- <p>建筑面积: {{ item.area }}</p>
        <p>床 位 数: {{ item.bed }}</p>
        <p>投 资 额: {{ item.money }}</p>
        <p>项目地点: {{ item.address }}</p> -->
        <pre>{{ item.tab }} </pre>
      </div>
      <div class="_m_content" v-else-if="$store.state.screenWidth <= 960">
        <!-- <p>建筑面积: {{ item.area }}</p>
        <p>床 位 数: {{ item.bed }}</p>
        <p>投 资 额: {{ item.money }}</p>
        <p>项目地点: {{ item.address }}</p> -->
        <pre>{{ item.tab }} </pre>
      </div>
      <div class="_btn" v-if="$store.state.screenWidth > 960">
        了解更多 <i class="iconfont icon-dianhua1"></i><span>400-0098-709</span>
      </div>
      <div class="_m_btn" v-else-if="$store.state.screenWidth <= 960">
        了解更多 <i class="iconfont icon-dianhua1"></i><span>400-0098-709</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      default: {},
    },
  },
  mounted() {
    // console.log(this.item);
  },
  methods: {
    showProjectDetail() {
      this.$router.push({
        // path: "/project/detail",
        name: "ProjectDetail",
        params: {
          id: this.item.id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
._case_card {
  width: 100%;
  height: 100%;
  position: relative;
  position: relative;
  overflow: hidden;
  background-repeat: no-repeat;
  // background-size: cover;
  background-size: 100% 100%;
  background-position: center;
  transition: background-size 0.4s ease-in-out;
  ._bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url("https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/case.png") no-repeat;
    background-size: 110% 110%;
    background-position: center;
  }
  > ._title {
    position: absolute;
    top: 0.21rem;
    left: 0.31rem;
    right: .31rem;
    transition: opacity 0.4s ease-in-out;
    letter-spacing: .01rem;
    ._name {
      font-size: 0.2rem;
      color: rgba(255, 255, 255, 0.8);
      font-weight: 800;
    }
    ._line {
      margin-top: 0.17rem;
      width: 0.4rem;
      height: 0.04rem;
      background: #ff8f21;
      border-radius: 0.04rem;
    }
  }
  >._m_title{
    position: absolute;
    top: 0.21rem;
    left: 0.31rem;
    right: .31rem;
    transition: opacity 0.4s ease-in-out;
    letter-spacing: .01rem;
    ._name {
      font-size: 0.26rem;
      color: rgba(255, 255, 255, 0.8);
      font-weight: 800;
    }
    ._line {
      margin-top: 0.17rem;
      width: 0.4rem;
      height: 0.04rem;
      background: #ff8f21;
      border-radius: 0.04rem;
    }
  }
  ._info {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 0.5rem 0.7rem 0 0.46rem;
    color: rgba(255, 255, 255, 0.8);
    background: rgba(0, 0, 0, 0.6);
    opacity: 0;
    transition: opacity 0.4s ease-in-out;
    cursor: pointer;
    ._title {
      font-size: 0.18rem;
      font-weight: bold;
    }
    ._m_title {
      font-size: 0.3rem;
      margin-bottom: 0.2rem;
      font-weight: bold;
    }
    ._content {
      margin-top: 0.4rem;
      font-size: 0.15rem;
      pre {
        line-height: 0.3rem;
      }
      padding: 0.1px;
    }
    ._m_content {
      font-size: 0.25rem;
      pre {
        line-height: 0.4rem;
        overflow: hidden;
      }
    }
    ._btn {
      width: 2.25rem;
      height: 0.36rem;
      line-height: 0.36rem;
      text-align: center;
      // padding: 0.1rem 0.3rem;
      background: #3660aa;
      border-radius: 0.02rem;
      font-size: 0.14rem;
      margin-top: 0.06rem;
      color: #fff;
      span {
        font-weight: bold;
        font-size: 0.18rem;
      }
    }
    ._m_btn {
      width: 3.55rem;
      height: 0.66rem;
      line-height: 0.66rem;
      text-align: center;
      // padding: 0.1rem 0.3rem;
      background: #3660aa;
      border-radius: 0.1rem;
      font-size: 0.28rem;
      margin-top: 0.06rem;
      color: #fff;
      font-weight: bold;
    }
  }
  &:hover {
    background-size: 120% 120%;
    transition: background-size 0.4s ease-in-out;
  }
  &:hover ._info {
    opacity: 1;
    transition: opacity 0.4s ease-in-out;
  }
  &:hover > ._title {
    opacity: 0;
    transition: opacity 0.4s ease-in-out;
  }
  &:hover > ._m_title {
    opacity: 0;
    transition: opacity 0.4s ease-in-out;
  }
  &:hover > ._bg {
    opacity: 0;
    transition: opacity 0.4s ease-in-out;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Index/CaseCard.vue